import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {QueryDic} from "@core/global";
import {DistributorGroup, DistributorGroupAddModel, DistributorGroupListItem} from "@/models";

export class DistributorGroupService {
    constructor(private baseApiFactory: BaseApiFactory) {
    }

    static $inject = ['BaseApiFactory'];

    public Search(query) {
        return this.baseApiFactory.getData<DistributorGroupListItem[]>('/api/DistributorGroups', query);
    }

    public GetById(id: number) {
        return this.baseApiFactory.getData<DistributorGroup>('/api/DistributorGroups/' + id);
    }

    public Insert(value: DistributorGroupAddModel) {
        return this.baseApiFactory.post<boolean>('/api/DistributorGroups', value);
    }

    public Update(value: DistributorGroupListItem) {
        return this.baseApiFactory.put<boolean>('/api/DistributorGroups', value);
    }

    public Delete(id: number) {
        return this.baseApiFactory.delete<boolean>('/api/DistributorGroups/' + id);
    }
}

lazyRegister.service('DistributorGroupService', DistributorGroupService);